import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Typography } from '@material-ui/core';
import ContainerCard from '../Shared/container-card';

export default ({ company, isLoading }) => {
  const { t } = useTranslation();

  if (isLoading) {
    return <div></div>;
  }

  return (
    <ContainerCard
      xs={12}
      md={12}
      lg={12}
      header={
        <Typography variant="h6">
          <i className="fa fa-suitcase"></i> {t('Company detail')}
        </Typography>
      }
      content={
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <div>
              <small className="font-weight-bold text-lowercase">{t('Name')}</small>
              <div className="text-uppercase">{company.name}</div>
            </div>
            <div>
              <small className="font-weight-bold text-lowercase">{t('Floor')}</small>
              <div className="text-uppercase">{company.floor || '-'}</div>
            </div>
            <div>
              <small className="font-weight-bold text-lowercase">{t('Room')}</small>
              <div className="text-uppercase">{company.room || '-'}</div>
            </div>
            <hr />
            <div>
              <small className="font-weight-bold">{t('My user roles in this company')}</small>
              {company.Roles.map((ur, i) => {
                return (
                  <div key={i}>
                    <div>
                      - <span className="text-uppercase">{t(ur.role)}</span>: &nbsp;
                      {t(`${ur.role}.description`)}.
                    </div>
                  </div>
                );
              })}
            </div>
          </Grid>
        </Grid>
      }
    />
  );
};
